import { Card, FormInstance } from 'antd';
import { ReactMediaRecorder } from 'react-media-recorder';

interface OnboardVideoStepProps {
  form: FormInstance<any>;
  totalSteps: number;
  currentStep: number;
}

export const OnboardVideoStep = ({ totalSteps, currentStep }: OnboardVideoStepProps) => {
  return (
    <Card title="Introduce yourself" extra={`Step ${currentStep} of ${totalSteps}`}>
      <ReactMediaRecorder
        video
        render={({ status, startRecording, stopRecording, mediaBlobUrl }) => (
          <div>
            <p>{status}</p>
            <button onClick={startRecording}>Start Recording</button>
            <button onClick={stopRecording}>Stop Recording</button>
            <video src={mediaBlobUrl} controls autoPlay loop />
          </div>
        )}
      />
    </Card>
  );
};
